<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-12-16 11:09:13
 * @LastEditTime: 2021-11-24 14:58:58
 * @LastEditors: zhaoshuai
-->
<template>
  <div class="flex sharing-v">
    <Header />
    <div class="info-item">
      <h1 class="text-center">能力水平考试论文提交</h1>
      <div class="info-area wrapper">
        <p class="text-center">
          请参考税务管理师CTM中级论文提交说明，<a
            href="https://guanhuifileserver.oss-cn-shanghai.aliyuncs.com/CTM_PAPER.pdf"
            target="_blank"
            >点击查看</a
          >。 提交截止日期：2021年12月10日 22:00。
        </p>
      </div>
    </div>
    <div class="info-item">
      <div class="upload-wrap">
        <a-upload-dragger
          class="uploader"
          name="file"
          :fileList="fileList"
          accept="application/pdf"
          :customRequest="putObject"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
          <p class="ant-upload-hint">支持文件类型：.pdf</p>
        </a-upload-dragger>
      </div>
    </div>
    <div class="text-center" style="margin-top: 50px">
      <a-button type="primary" @click="update"> 确认提交 </a-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");
let OSS = require("ali-oss");
export default {
  name: "Login",
  components: {
    Header,
  },
  data() {
    return {
      name: "",
      imgUrl: "",
      aliOss: null,
      fileList: [],
      txt: "",
    };
  },
  mounted() {
    this.aliOssInit();
    this.canSetThesisAct(this.$route.query.id).then((res) => {
      if (res.data.status == 2000) {
        this.name = res.data.data;
      } else {
        this.$error({
          title: "请注意",
          okText: "知道了",
          content: res.data.message,
        });
      }
    });
  },
  methods: {
    ...mapActions(["getStudentInfo", "canSetThesisAct", "uploadThesisAct"]),
    handleChange(info) {
      // this.putObject(info.file.originFileObj);
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.$message.success(`${info.file.name} 上传成功`);
      } else if (status === "error") {
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },
    aliOssInit() {
      this.aliOss = new OSS({
        accessKeyId: "LTAIWc0CPm9srRPe",
        accessKeySecret: "XgJ1d8CbDIMDMNVOAqcJSvfTtro9GE",
        bucket: "guanhuifileserver",
        region: "oss-cn-shanghai",
      });
    },
    // 支持File对象、Blob数据以及OSS Buffer。
    async putObject(data) {
      if (!this.name) {
        this.$error({
          title: "请注意",
          okText: "知道了",
          content: "无报考论文信息，不能上传",
        });
        return;
      }
      try {
        // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
        let objName = `jk/${this.name}`;
        let result = await this.aliOss.put(objName, data.file);

        this.fileList.push({
          uid: this.randomString(), // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
          name: this.name, // 文件名
          status: "done", // 状态有：uploading done error removed
          response: result, // 服务端响应内容
        });
        this.imgUrl = result.url;
      } catch (e) {
        console.log(e);
      }
    },
    update() {
      if (!this.imgUrl) {
        this.$error({
          title: "请注意",
          okText: "知道了",
          content: "请先选择文件",
        });
        return;
      }
      this.uploadThesisAct({
        enrollInfoId: this.$route.query.id,
        url: this.imgUrl,
      }).then((res) => {
        if (res.data.status == 2000) {
          this.$message.success(`提交成功`);
          this.$router.push("/thesis-result");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    randomString(len) {
      len = len || 32;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
};
</script>

<style scoped>
.next-box {
  margin-top: 30px;
  justify-content: center;
}
.info-item {
  margin-top: 30px;
}
.info-item h3 {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: bold;
}
.info-area {
  margin-top: 50px;
  padding: 40px;
  background: #f9f9f9;
}
.info-area p {
  margin: 0;
  text-align: center;
}
.info-area p a {
  color: #0091ff;
}
.upload-wrap {
  width: 400px;
  height: 200px;
  margin: 0 auto;
}
</style>